import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { ID } from "../../utils/id";
import {
  COMPANY_SETTING_FRAGMENT,
  CompanySettingFragment,
} from "../fragment/company.setting.fragment";

interface Data {
  setting: CompanySettingFragment;
}

interface Variables {
  name: string;
  company: ID;
}

const QUERY = gql`
  query getCompanySettingByName($name: String!, $company: ID!) {
    setting: getCompanySettingByName(name: $name, company: $company) {
      ...CompanySetting
    }
  }
  ${COMPANY_SETTING_FRAGMENT}
`;
export const useCompanySettingByNameQuery = (
  data?: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> => useQuery<Data, Variables>(QUERY, data);
